exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-c3b19728]{font-size:15px;text-align:justify}.black[data-v-c3b19728]{color:#fff;height:50px;font-size:20px;font-weight:700}.black1[data-v-c3b19728]{line-height:40px;font-size:18px}td[data-v-c3b19728]{width:50%}", ""]);

// exports
